// ADD YOUR OWN GOOGLE MAPS API KEY HERE
export const MAPS_API_KEY = 'AIzaSyAfVuZmWrSFqtZFomKg_1K5VuVgdNVBKCs'
